import ContactHero from "./components/ContactHero";
import ContactInfo from "./components/ContactInfo";
import ContactMap from "./components/ContactMap";
import ContactForm from "./components/ContactForm";
import ContactQuickActions from "./components/ContactQuickActions";

export default function ContactPage() {
  return (
    <main>
      <ContactHero />
      <ContactInfo />
      <ContactMap />
      <ContactForm />
      <ContactQuickActions />
    </main>
  );
}